/**
 * Booking Offices screen — a tabbed wrapper (mirrors SalesScreen):
 *   • Booking Office Sales (ticket takings by office/channel — default)
 *   • BO by Time (exec only — booking-office throughput & staffing by hour)
 *
 * The exec tab is only rendered for members of SG-Exec-Reports. That is
 * presentation only: every endpoint behind it independently requires the group
 * server-side, so hiding the button is not what enforces the restriction.
 */
import { useState } from "react";
import { BookingOfficeSalesDashboard } from "./BookingOfficeSalesDashboard";
import { BOByTime } from "./BOByTime";
import "./resource-bookings.css";

type Tab = "sales" | "exec";

export function BookingOfficesScreen({ isExec }: { isExec: boolean }) {
  const [tab, setTab] = useState<Tab>("sales");

  // If access is lost mid-session, fall back rather than rendering a tab the
  // API will refuse to serve.
  const active: Tab = tab === "exec" && !isExec ? "sales" : tab;

  return (
    <>
      <div className="sales-screen-tabs" role="tablist" aria-label="Booking Offices">
        <button
          type="button" role="tab" aria-selected={active === "sales"}
          className={"sst-tab" + (active === "sales" ? " active" : "")}
          onClick={() => setTab("sales")}
        >
          Booking Office Sales
        </button>
        {isExec && (
          <button
            type="button" role="tab" aria-selected={active === "exec"}
            className={"sst-tab" + (active === "exec" ? " active" : "")}
            onClick={() => setTab("exec")}
          >
            BO by Time
          </button>
        )}
      </div>
      {active === "sales" && <BookingOfficeSalesDashboard />}
      {active === "exec" && <BOByTime />}
    </>
  );
}
